import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconListViewOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M3 12.75v-1.5h21v1.5zm0-6v-1.5h21v1.5zm0 12v-1.5h21v1.5zm-3-6v-1.5h1.5v1.5zm0-6v-1.5h1.5v1.5zm0 12v-1.5h1.5v1.5z" /></svg>
);
